module.exports = __webpack_public_path__ + "img/errorpagenotfound.8c857e8.webp";